<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div>
        PORUKA:
        <input type="tect" v-model="newsboardNotification.text" />
      </div>
      <div>
        AKTIVNO:
        <input type="checkbox" v-model="newsboardNotification.isActive" checked />
      </div>
      <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="!isValid" v-on:click="handleSave">
          SPREMI
        </button>
        <button type="button" v-on:click="$emit('close')">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('close')"></a>
  </div>
</template>

<script>
export default {
  name: 'AddEditNewsboardModal',
  props: {
    id: Number,
    text: String,
    isActive: Boolean,
  },
  data() {
    return {
      newsboardNotification: {
        id: null,
        text: '',
        isActive: true,
      },
    };
  },
  mounted() {
    if (this.id && this.text && this.isActive) {
      this.newsboardNotification = {
        id: this.id,
        text: this.text,
        isActive: this.isActive,
      };
    }
  },
  methods: {
    handleSave: function() {
      const saveFunction = this.newsboardNotification.id ? this.handleUpdate : this.handleCreate;

      saveFunction().then(() => {
        this.$emit('close');
        this.$emit('afterSave');
      });
    },
    handleCreate: function() {
      const toAdd = {
        text: this.newsboardNotification.text,
        isActive: this.newsboardNotification.isActive,
      };

      return this.$axios.post(`${this.$API_URL}/newsboard/add`, toAdd).catch(() => {
        alert('Dodavanje obavjesti neuspješno. Prekoračenje dozvoljene duljine teksta.');
      });
    },
    handleUpdate: function() {
      return this.$axios.post(`${this.$API_URL}/newsboard/edit`, this.newsboardNotification).catch(() => {
        alert('Edit obavjesti neuspješan. Nevaljan unos ili zabranjen pristup.');
      });
    },
  },
  computed: {
    isValid: function() {
      return !!this.newsboardNotification.text;
    },
  },
};
</script>
